/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

export default function EmployeeLeaveRequests() {
  const [leaves, setLeaves]         = useState([]);
  const [loading, setLoading]       = useState(false);
  const [leaveType, setLeaveType]   = useState({});
  const [editMode, setEditMode]     = useState(null);
  const [editData, setEditData]     = useState({});
  const [filterDriver, setFilter]   = useState("");
  const [filterStatus, setFStatus]  = useState("");
  const [startDate, setStart]       = useState("");
  const [endDate, setEnd]           = useState("");

  const fetchLeaves = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/advance/leaves`);
      setLeaves(res.data || []);
    } catch (e) {
      console.error(e);
      alert("Error: " + (e?.response?.data?.message || e.message || "Operation failed."));
    }
    setLoading(false);
  };

  useEffect(() => { fetchLeaves(); }, []);

  const handleAction = async (id, status) => {
    if (status === "Approved" && !leaveType[id]) {
      alert("Please select leave type before approving."); return;
    }
    try {
      await axios.put(`${API_BASE_URL}/advance/leaves/${id}`, { status, leaveType: leaveType[id] || null });
      fetchLeaves();
    } catch (e) { alert("Action failed"); }
  };

  const handleUpdate = async (id) => {
    try {
      await axios.put(`${API_BASE_URL}/advance/leaves/${id}`, editData);
      setEditMode(null); fetchLeaves();
    } catch (e) { alert("Update failed"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this leave request?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/advance/leaves/${id}`);
      fetchLeaves();
    } catch (e) { alert("Delete failed"); }
  };

  const fmt = (d) => d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

  const filtered = leaves.filter(r => {
    const matchD = !filterDriver || (r.driverId || "").toLowerCase().includes(filterDriver.toLowerCase());
    const matchS = !filterStatus || r.status === filterStatus;
    return matchD && matchS;
  });

  const pending   = filtered.filter(r => r.status === "Pending");
  const processed = filtered.filter(r => r.status !== "Pending");

  const downloadCSV = () => {
    const h = "Driver ID,Start Date,End Date,Reason,Status,Leave Type\n";
    const rows = filtered.map(r => `${r.driverId},${r.startDate},${r.endDate},${r.reason},${r.status},${r.leaveType || ""}`).join("\n");
    const blob = new Blob([h + rows], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = `leave_requests_${startDate || "all"}_to_${endDate || "all"}.csv`; a.click();
  };

  const S = {
    container: { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:   { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:     { padding: "8px 10px", border: "1px solid #ccc", borderRadius: 5, fontSize: 13 },
    select:    { padding: "8px 10px", border: "1px solid #ccc", borderRadius: 5, fontSize: 13, background: "#fff" },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "8px 14px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:  { background: "#000", color: "#fff", border: "none", padding: "8px 14px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    table:     { width: "100%", borderCollapse: "collapse", marginTop: 10, marginBottom: 24 },
    thY:       { background: "#FFC107", color: "#000", padding: "10px 12px", textAlign: "center", border: "1px solid #ccc", fontSize: 13, fontWeight: "bold" },
    thB:       { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:        { border: "1px solid #000", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
    sectionLbl:{ fontWeight: "bold", fontSize: 14, marginTop: 20, marginBottom: 8, padding: "0 16px" },
  };

  const badgeStyle = (s) => ({
    background: s === "Approved" ? "#e6f9ee" : s === "Rejected" ? "#fde8e8" : "#fff8e1",
    color:      s === "Approved" ? "#27ae60" : s === "Rejected" ? "#c0392b" : "#d68910",
    padding: "3px 10px", borderRadius: 10, fontSize: 11, fontWeight: "bold",
  });

  const renderTable = (rows, isPending) => (
    <div style={{ overflowX: "auto", padding: "0 16px" }}>
      <table style={S.table}>
        <thead>
          <tr>
            {["Driver ID","Start Date","End Date","Reason","Status","Leave Type","Actions"].map(h => (
              <th key={h} style={isPending ? S.thY : S.thB}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td colSpan={7} style={{ ...S.td, color: "#888" }}>No records</td></tr>
          ) : rows.map((r, i) => (
            <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
              <td style={S.td}>{r.driverId}</td>
              <td style={S.td}>{fmt(r.startDate)}</td>
              <td style={S.td}>{fmt(r.endDate)}</td>
              <td style={S.td}>
                {editMode === r._id
                  ? <input style={{ ...S.input, width: "100%" }} value={editData.reason || ""} onChange={e => setEditData({ ...editData, reason: e.target.value })} />
                  : r.reason}
              </td>
              <td style={S.td}><span style={badgeStyle(r.status)}>{r.status}</span></td>
              <td style={S.td}>
                {isPending ? (
                  <select style={S.select} onChange={e => setLeaveType({ ...leaveType, [r._id]: e.target.value })}>
                    <option value="">Select Type</option>
                    <option>Paid Leave</option>
                    <option>Unpaid Leave</option>
                  </select>
                ) : (r.leaveType || "—")}
              </td>
              <td style={S.td}>
                {isPending ? (
                  <div style={{ display: "flex", gap: 6, justifyContent: "center", flexWrap: "wrap" }}>
                    <button style={{ ...S.btnYellow, padding: "5px 10px" }}
                      onClick={() => handleAction(r._id, "Approved")} disabled={!leaveType[r._id]}>
                      Approve
                    </button>
                    <button style={{ ...S.btnYellow, padding: "5px 10px" }}
                      onClick={() => handleAction(r._id, "Rejected")}>
                      Reject
                    </button>
                  </div>
                ) : editMode === r._id ? (
                  <button style={{ ...S.btnYellow, padding: "5px 10px" }} onClick={() => handleUpdate(r._id)}>Update</button>
                ) : (
                  <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                    <button style={{ ...S.btnYellow, padding: "5px 10px" }} onClick={() => { setEditMode(r._id); setEditData(r); }}>Edit</button>
                    <button style={{ ...S.btnYellow, padding: "5px 10px" }} onClick={() => handleDelete(r._id)}>Delete</button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Leave Requests</h2>

      <div style={S.toolbar}>
        <input style={S.input} placeholder="Filter by Driver ID..." value={filterDriver} onChange={e => setFilter(e.target.value)} />
        <select style={S.select} value={filterStatus} onChange={e => setFStatus(e.target.value)}>
          <option value="">All Status</option>
          <option>Pending</option>
          <option>Approved</option>
          <option>Rejected</option>
        </select>
        <input style={S.input} type="date" value={startDate} onChange={e => setStart(e.target.value)} />
        <input style={S.input} type="date" value={endDate}   onChange={e => setEnd(e.target.value)} />
        <button style={S.btnYellow} onClick={downloadCSV}>⬇ Download</button>
      </div>

      {loading ? (
        <p style={{ padding: 20 }}>Loading leave requests...</p>
      ) : (
        <>
          <div style={S.sectionLbl}>Pending Requests ({pending.length})</div>
          {renderTable(pending, true)}
          <div style={S.sectionLbl}>Approved / Rejected Requests ({processed.length})</div>
          {renderTable(processed, false)}
        </>
      )}
    </div>
  );
}
